import { render, staticRenderFns } from "./SocketFunc.vue?vue&type=template&id=49b91e8b&"
import script from "./SocketFunc.vue?vue&type=script&lang=js&"
export * from "./SocketFunc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports